import Vue from "vue";

Vue.component("chart-world-cloud", {
	props: ['loading', 'chartData', 'hasData'],
    data() {
        return {
            footer: ""
        };
    },
    computed: {
        chartOptions: function () {
            let self = this;
            return {
                exporting: { enabled: false },
                accessibility: {
                    screenReaderSection: {
                        beforeChartFormat: '<h5>{chartTitle}</h5>' +
                            '<div>{chartSubtitle}</div>' +
                            '<div>{chartLongdesc}</div>' +
                            '<div>{viewTableButton}</div>'
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    type: 'wordcloud',
                    data: self.chartData,
                    name: 'Occurrences'
                }],
                title: {
                    text: ''
                }
            }
        }
    },
    mounted() {
        this.$emit("mounted");
    },
	template: `
		<div>
		    <wto-chart :loading="loading"
		                   :has-data="hasData"
		                   :chart-options="chartOptions"
		                   :footer="footer"></wto-chart>
		</div>
	`
});